
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Von Zeit zu Zeit ist ein Auslassversuch sinnvoll, um zu prüfen, ob der Effekt auch ohne Medikamente anhält. In der Regel stoppt man daher die Medikation nach rund sechs Monaten. Bei Kopfschmerzen kann das Alter im Übrigen ein Segen sein: Von den 50- bis 64-Jährigen in der Schweiz gab in der eingangs erwähnten Umfrage «nur» noch jeder Vierte an, in den letzten vier Wochen Kopfschmerzen gehabt zu haben. Bei den über 65-Jährigen war es nur noch jeder Siebte.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;